import { CSSObject } from '@emotion/react';
import { useTheme } from '@cvent/carina/components/ThemeProvider';

export const useFormStyle = (): Record<string, CSSObject> => {
  const { font, spacing, backgroundColor } = useTheme();

  return {
    form: {
      padding: spacing['6'],
      justifyContent: 'space-between'
    },
    title: {
      marginTop: 0,
      marginBottom: 0,
      fontFamily: font.base.family,
      fontWeight: font.base.weight.regular,
      fontSize: font.base.size['6'],
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    subtitle: {
      marginTop: 0,
      marginBottom: 0,
      fontFamily: font.base.family,
      fontWeight: font.base.weight.regular,
      fontSize: font.base.size['4'],
      color: font.color.neutral.base,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    productSelect: {
      marginTop: 0,
      marginBottom: 0,
      fontFamily: font.base.family,
      fontWeight: font.base.weight.regular,
      fontSize: font.base.size['6'],
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    productSelectMenu: {
      marginTop: 0,
      marginBottom: 0,
      fontFamily: font.base.family,
      fontWeight: font.base.weight.regular,
      fontSize: font.base.size['6'],
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      lineHeight: 1.25
    },
    textLink: {
      marginTop: 0,
      marginBottom: 0,
      fontFamily: font.base.family,
      fontWeight: font.base.weight.regular,
      fontSize: font.base.size['3'],
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    text: {
      marginTop: 0,
      marginBottom: 0,
      fontFamily: font.base.family,
      fontWeight: font.base.weight.regular,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    centerText: {
      marginTop: 0,
      marginBottom: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    defaultText: {
      color: backgroundColor.neutral.fill.base,
      marginTop: 0,
      marginBottom: 0,
      fontFamily: font.base.family,
      fontWeight: font.base.weight.regular,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    errorText: {
      color: backgroundColor.danger.fill.base,
      marginTop: 0,
      marginBottom: 0,
      fontFamily: font.base.family,
      fontWeight: font.base.weight.regular,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    successText: {
      color: backgroundColor.success.fill.base,
      marginTop: 0,
      marginBottom: 0,
      fontFamily: font.base.family,
      fontWeight: font.base.weight.regular,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
  };
};
